module.exports = __webpack_public_path__ + "static/media/618_Carnarvon_Lobby_1-min.9f5fb544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/virtualtour/618_Carnarvon_Lobby_1-min.jpg
// module id = 48
// module chunks = 0